import { IStore } from "redux/store";
import { IReportStore } from "./@types";
import { jobSelectors } from "redux/_core/job";
import { getType } from "typesafe-actions";
import reportActions from "./actions";

const reportSelectors = {
	_getStore(store: IStore) {
		return store.app.report;
	},
	getRawGarbageData(reportStore: IReportStore) {
		return reportStore?.garbage?.rawGarbageData ?? [];
	},
	getGarbageCustomSearchData(reportStore: IReportStore) {
		return reportStore?.garbage?.garbageCustomSearchData ?? [];
	},
	getVesselId(reportStore: IReportStore) {
		return reportStore?.garbage?.vesselId ?? "";
	},
	getGarbageYear(reportStore: IReportStore) {
		return reportStore?.garbage?.year ?? "";
	},
	getRawBilgeWaterData(reportStore: IReportStore) {
		return reportStore?.bilgeWater?.rawBilgeWaterData ?? [];
	},
	getBilgeWaterVesselId(reportStore: IReportStore) {
		return reportStore?.bilgeWater?.vesselId ?? "";
	},
	getBilgeWaterYear(reportStore: IReportStore) {
		return reportStore?.bilgeWater?.year ?? "";
	},
	getQuarterLabels(reportStore: IReportStore) {
		return reportStore?.bilgeWater?.quarterLabels;
	},
	getBilgeWaterAllVesselsData(reportStore: IReportStore) {
		return reportStore?.bilgeWater?.allVesselBilgeWaterData;
	},
	getBilgeWaterCustomSearchData(reportStore: IReportStore) {
		return reportStore?.bilgeWater?.customSearchData ?? [];
	},
	getGarbageDischargeAllVesselsData(reportStore: IReportStore) {
		return reportStore?.garbage?.allVesselsGarbageDischargeData;
	},
	getGarbageCategoryAllVesselsData(reportStore: IReportStore) {
		return reportStore?.garbage?.allVesselsGarbageCategoryData;
	},
	getRawOrsData(reportStore: IReportStore) {
		return reportStore?.ors?.rawOrsData ?? [];
	},
	getRawVesselSpecificOrsData(reportStore: IReportStore) {
		return reportStore?.ors?.rawOrsVesselSpecificData ?? [];
	},
	getOrsVesselId(reportStore: IReportStore) {
		return reportStore?.ors?.vesselId ?? "";
	},
	getOrsYear(reportStore: IReportStore) {
		return reportStore?.ors?.year ?? "";
	},
	getGenericVesselId(reportStore: IReportStore) {
		return reportStore?.vesselId ?? "";
	},
	getGenericVesselType(reportStore: IReportStore) {
		return reportStore?.vesselType ?? "";
	},
	getGenericVesselClass(reportStore: IReportStore) {
		return reportStore?.vesselClass ?? "";
	},
	getGenericYear(reportStore: IReportStore) {
		return reportStore?.year;
	},
	getGenericFilters(reportStore: IReportStore) {
		return reportStore?.filters;
	},
	getGenericPagination(reportStore: IReportStore) {
		return reportStore?.pagination;
	},
	getRawCargoSlopData(reportStore: IReportStore) {
		return reportStore?.cargoSlop?.rawCargoSlopData ?? [];
	},
	getRawVesselSpecificCargoSlopData(reportStore: IReportStore) {
		return reportStore?.cargoSlop?.rawCargoSlopVesselSpecificData ?? [];
	},
	getRawOilSpillsInWaterData(reportStore: IReportStore) {
		return reportStore?.oilSpillsInWater?.rawOilSpillsInWaterData ?? [];
	},
	getRawVesselSpecificOilSpillsInWaterData(reportStore: IReportStore) {
		return (
			reportStore?.oilSpillsInWater?.rawOilSpillsInWaterVesselSpecificData ?? []
		);
	},
	getRawComprehensiveNoonReportData(reportStore: IReportStore) {
		return (
			reportStore?.comprehensiveNoonReport?.rawComprehensiveNoonReportData ?? []
		);
	},
	getRawVesselSpecificComprehensiveNoonReportData(reportStore: IReportStore) {
		return (
			reportStore?.comprehensiveNoonReport
				?.rawComprehensiveNoonReportVesselSpecificData ?? []
		);
	},
	getCNRRangesRawVesselList(reportStore: IReportStore) {
		return reportStore?.cnrRanges?.rawCNRRangeVesselsData;
	},
	getCNRRangesPagination(reportStore: IReportStore) {
		return reportStore?.cnrRanges?.pagination;
	},
	getCNRRangesColumns(reportStore: IReportStore) {
		return reportStore?.cnrRanges?.columns;
	},
	getCNRVesselSubType(reportStore: IReportStore) {
		return reportStore?.cnrRanges?.vesselSubType;
	},
	getCNRRangesVesselsSelected(reportStore: IReportStore) {
		return reportStore?.cnrRanges?.vesselsSelected;
	},
	getCNRRangesReportTypeSelected(reportStore: IReportStore) {
		return reportStore?.cnrRanges?.reportType;
	},
	getCNRRangesBaseRangeType(reportStore: IReportStore) {
		return reportStore?.cnrRanges?.baseRangeType;
	},
	getCNRRangesConfig(reportStore: IReportStore) {
		return reportStore?.cnrRanges?.config;
	},
	getCNRRangesRangeInfo(reportStore: IReportStore) {
		return reportStore?.cnrRanges?.rangeInfo;
	},
	getCNRRangesIsEditModalVisible(reportStore: IReportStore) {
		return reportStore?.cnrRanges?.isEditModalVisible;
	},
	getRawNavnucData(reportStore: IReportStore) {
		return reportStore?.navnuc?.rawNavnucData ?? [];
	},
	jobToLoadGarbageCustomSearch(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.garbageCustomSearchLoad),
		);
	},
	jobToLoadGarbageReport(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.garbageReportLoad),
		);
	},
	jobToLoadVesselSpecificBilgeReport(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.bilgeWaterReportLoad),
		);
	},
	jobToLoadVesselTenantBilgeReport(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.bilgeWaterAllVesselsAggregateLoad),
		);
	},
	jobToLoadBilgeWaterCustomSearch(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.bilgeWaterCustomSearchLoad),
		);
	},
	jobToLoadAllVesselsGarbageCategoryReport(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.garbageCategoryAllVesselsLoad),
		);
	},
	jobToLoadAllVesselsGarbageDischargeReport(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.garbageDischargeAllVesselsLoad),
		);
	},
	jobToLoadAllVesselsOrsAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.orsAllVesselAggregateLoad),
		);
	},
	jobToLoadVesselSpecificOrsAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.orsVesselSpecificAggregateLoad),
		);
	},
	jobToLoadAllVesselsCargoSlopAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.cargoSlopAllVesselAggregateLoad),
		);
	},
	jobToLoadVesselSpecificCargoSlopAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.cargoSlopVesselSpecificAggregateLoad),
		);
	},
	jobToLoadAllVesselsOilSpillsInWaterAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.oilSpillsInWaterAllVesselAggregateLoad),
		);
	},
	jobToLoadVesselSpecificOilSpillsInWaterAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(
				reportActions.commands.oilSpillsInWaterVesselSpecificAggregateLoad,
			),
		);
	},
	jobToLoadAllVesselsComprehensiveNoonReport(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.comprehensiveNoonReportAllVesselLoad),
		);
	},
	jobCNRRangesVesselsLoad(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.cnrRangesVesselsLoad),
		);
	},
	jobToUpdateCNRRangesCell(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.cnrRangesRangeCellUpdate),
		);
	},
	jobToLoadNavnuc(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.navnucLoad),
		);
	},
	jobToUploadCNRRangesCSVFile(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.cnrRangesCSVFileUpload),
		);
	},
	jobToLoadVesselSpecificPackagingAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.packagingVesselSpecificAggregateDataLoad),
		);
	},
	jobToLoadAllVesselsPackagingAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.packagingAllVesselAggregateDataLoad),
		);
	},
	jobToLoadVesselSpecificCleaningChemicalsAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(
				reportActions.commands.cleaningChemicalsVesselSpecificAggregateDataLoad,
			),
		);
	},
	jobToLoadAllVesselsCleaningChemicalsAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(
				reportActions.commands.cleaningChemicalsAllVesselAggregateDataLoad,
			),
		);
	},
	jobToLoadVesselSpecificEmissionsAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.emissionsVesselSpecificAggregateDataLoad),
		);
	},
	jobToLoadAllVesselsEmissionsAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.emissionsAllVesselAggregateDataLoad),
		);
	},
	jobToLoadVesselSpecificRefrigerantAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(
				reportActions.commands.refrigerantVesselSpecificAggregateDataLoad,
			),
		);
	},
	jobToLoadAllVesselsRefrigerantAggregate(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.refrigerantAllVesselAggregateDataLoad),
		);
	},
	jobToLoadRefrigerantCustomSearch(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.refrigerantCustomSearchLoad),
		);
	},
	jobToLoadEmfFleetUsageData(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.emfFleetUsageDataLoad),
		);
	},
	getPackagingVesselSpecificAggregateData(reportStore: IReportStore) {
		return reportStore?.packaging?.vesselSpecificAggregateData;
	},
	getPackagingAllVesselsAggregateData(reportStore: IReportStore) {
		return reportStore?.packaging?.allVesselAggregateData;
	},
	getCleaningChemicalsVesselSpecificAggregateData(reportStore: IReportStore) {
		return reportStore?.cleaningChemicals?.vesselSpecificAggregateData;
	},
	getCleaningChemicalsAllVesselsAggregateData(reportStore: IReportStore) {
		return reportStore?.cleaningChemicals?.allVesselAggregateData;
	},
	getEmissionsVesselSpecificAggregateData(reportStore: IReportStore) {
		return reportStore?.emission?.vesselSpecificAggregateData;
	},
	getEmissionsAllVesselsAggregateData(reportStore: IReportStore) {
		return reportStore?.emission?.allVesselAggregateData;
	},
	getRefrigerantVesselSpecificAggregateData(reportStore: IReportStore) {
		return reportStore?.refrigerant?.vesselSpecificAggregateData;
	},
	getRefrigerantAllVesselsAggregateData(reportStore: IReportStore) {
		return reportStore?.refrigerant?.allVesselAggregateData;
	},
	getRefrigerantCustomSearchData(reportStore: IReportStore) {
		return reportStore?.refrigerant?.customSearchData ?? [];
	},
	jobToLoadPackagingCustomSearch(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.packagingCustomSearchLoad),
		);
	},
	jobToLoadCleaningChemicalsCustomSearch(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.cleaningChemicalsCustomSearchLoad),
		);
	},
	getPackagingCustomSearchData(reportStore: IReportStore) {
		return reportStore?.packaging?.customSearchData ?? [];
	},
	getCleaningChemicalsCustomSearchData(reportStore: IReportStore) {
		return reportStore?.cleaningChemicals?.customSearchData ?? [];
	},
	getORSCustomSearchData(reportStore: IReportStore) {
		return reportStore?.ors?.customSearchData ?? [];
	},
	getCargoSlopCustomSearchData(reportStore: IReportStore) {
		return reportStore?.cargoSlop?.customSearchData ?? [];
	},
	getEmissionsCustomSearchData(reportStore: IReportStore) {
		return reportStore?.emission?.customSearchData ?? [];
	},
	jobToLoadORSCustomSearch(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.orsCustomSearchLoad),
		);
	},
	jobToLoadCargoSlopCustomSearch(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.cargoSlopCustomSearchLoad),
		);
	},
	jobToLoadEmissionsCustomSearch(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.emissionsCustomSearchLoad),
		);
	},
	getEmfFleetUsageData(reportStore: IReportStore) {
		return reportStore?.emfFleetUsageData;
	},
	getBiofouling1FleetData(reportStore: IReportStore) {
		return reportStore?.biofouling1FleetData ?? [];
	},
	getBiofouling2FleetData(reportStore: IReportStore) {
		return reportStore?.biofouling2FleetData ?? [];
	},
	jobToLoadBiofouling1Data(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.biofouling1FleetDataLoad),
		);
	},
	jobToLoadBiofouling2Data(reportStore: IReportStore) {
		return jobSelectors.getJobStatus(
			reportStore,
			getType(reportActions.commands.biofouling2FleetDataLoad),
		);
	},
};

export default reportSelectors;
